module.exports = __webpack_public_path__ + "static/img/one.6bdba7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/9/one.png
// module id = JyYK
// module chunks = 1